import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { DAY_IN_MS } from '@office-start/date-utility';
import { createEncryptionPlugin, createExpirationPlugin, readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { recommendedPersistenceVersion } from '../constants';
import { fetchFileTypes } from '../getFileTypes';
export function createPersistenceKey(fileTypes, persistentKey) {
    return JSON.stringify([persistentKey, fileTypes.join(',')]);
}
export function createPersistencePluginsForWrite(encryptionKeyResult) {
    var plugins = [];
    var key = encryptionKeyResult.key;
    if (key) {
        plugins.push(createEncryptionPlugin(key));
    }
    plugins.push(createExpirationPlugin(60 * DAY_IN_MS));
    return plugins;
}
export var removeItemFromPersistence = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var fileTypes, plugins, pluginsForRead, cacheRead, newData;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                fileTypes = fetchFileTypes(props.isOfficeFeed ? undefined : props.docProps.docFileType, props.pdfEnabled, props.upcomingMeetingEnabled, props.visioEnabled);
                plugins = createPersistencePluginsForWrite(props.encryptionKeyResult);
                pluginsForRead = __spreadArray([], __read(plugins), false).reverse();
                return [4 /*yield*/, readFromSimplePersistence({
                        userId: props.identity.puid,
                        collectionName: props.persistenceKey,
                        collectionVersion: recommendedPersistenceVersion,
                        key: createPersistenceKey(fileTypes, props.persistenceKey),
                        plugins: pluginsForRead,
                    })];
            case 1:
                cacheRead = _d.sent();
                newData = props.isOfficeFeed
                    ? (_a = cacheRead.data) === null || _a === void 0 ? void 0 : _a.items.filter(function (doc) {
                        return doc && doc.itemId !== props.docProps.docId;
                    })
                    : ((_c = (_b = cacheRead.data) === null || _b === void 0 ? void 0 : _b.documents_group.documents) === null || _c === void 0 ? void 0 : _c.filter(function (doc) {
                        return doc && doc.id !== props.docProps.docId;
                    })) || [];
                writeToSimplePersistence({
                    userId: props.identity.puid,
                    collectionName: props.persistenceKey,
                    collectionVersion: recommendedPersistenceVersion,
                    key: createPersistenceKey(fileTypes, props.persistenceKey),
                    data: newData,
                    plugins: plugins,
                });
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=persistenceUtilities.js.map